"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IEntityreturnFrozen = exports.IEntityreturnInactive = exports.IEntityreturnCode = void 0;
var IEntityreturnCode;
(function (IEntityreturnCode) {
    IEntityreturnCode["R_R01"] = "R01";
    IEntityreturnCode["R_R02"] = "R02";
    IEntityreturnCode["R_R03"] = "R03";
    IEntityreturnCode["R_R04"] = "R04";
    IEntityreturnCode["R_R05"] = "R05";
    IEntityreturnCode["R_R06"] = "R06";
    IEntityreturnCode["R_R07"] = "R07";
    IEntityreturnCode["R_R08"] = "R08";
    IEntityreturnCode["R_R09"] = "R09";
    IEntityreturnCode["R_R10"] = "R10";
    IEntityreturnCode["R_R11"] = "R11";
    IEntityreturnCode["R_R12"] = "R12";
    IEntityreturnCode["R_R13"] = "R13";
    IEntityreturnCode["R_R14"] = "R14";
    IEntityreturnCode["R_R15"] = "R15";
    IEntityreturnCode["R_R16"] = "R16";
    IEntityreturnCode["R_R17"] = "R17";
    IEntityreturnCode["R_R18"] = "R18";
    IEntityreturnCode["R_R19"] = "R19";
    IEntityreturnCode["R_R20"] = "R20";
    IEntityreturnCode["R_R21"] = "R21";
    IEntityreturnCode["R_R22"] = "R22";
    IEntityreturnCode["R_R23"] = "R23";
    IEntityreturnCode["R_R24"] = "R24";
    IEntityreturnCode["R_R25"] = "R25";
    IEntityreturnCode["R_R26"] = "R26";
    IEntityreturnCode["R_R27"] = "R27";
    IEntityreturnCode["R_R28"] = "R28";
    IEntityreturnCode["R_R29"] = "R29";
    IEntityreturnCode["R_R30"] = "R30";
    IEntityreturnCode["R_R31"] = "R31";
    IEntityreturnCode["R_R32"] = "R32";
    IEntityreturnCode["R_R33"] = "R33";
    IEntityreturnCode["R_R34"] = "R34";
    IEntityreturnCode["R_R35"] = "R35";
    IEntityreturnCode["R_R36"] = "R36";
    IEntityreturnCode["R_R37"] = "R37";
    IEntityreturnCode["R_R38"] = "R38";
    IEntityreturnCode["R_R39"] = "R39";
    IEntityreturnCode["R_R40"] = "R40";
    IEntityreturnCode["R_R41"] = "R41";
    IEntityreturnCode["R_R42"] = "R42";
    IEntityreturnCode["R_R43"] = "R43";
    IEntityreturnCode["R_R44"] = "R44";
    IEntityreturnCode["R_R45"] = "R45";
    IEntityreturnCode["R_R46"] = "R46";
    IEntityreturnCode["R_R47"] = "R47";
    IEntityreturnCode["R_R50"] = "R50";
    IEntityreturnCode["R_R51"] = "R51";
    IEntityreturnCode["R_R52"] = "R52";
    IEntityreturnCode["R_R53"] = "R53";
    IEntityreturnCode["R_R61"] = "R61";
    IEntityreturnCode["R_R62"] = "R62";
    IEntityreturnCode["R_R63"] = "R63";
    IEntityreturnCode["R_R64"] = "R64";
    IEntityreturnCode["R_R65"] = "R65";
    IEntityreturnCode["R_R66"] = "R66";
    IEntityreturnCode["R_R67"] = "R67";
    IEntityreturnCode["R_R68"] = "R68";
    IEntityreturnCode["R_R69"] = "R69";
    IEntityreturnCode["R_R70"] = "R70";
    IEntityreturnCode["R_R71"] = "R71";
    IEntityreturnCode["R_R72"] = "R72";
    IEntityreturnCode["R_R73"] = "R73";
    IEntityreturnCode["R_R74"] = "R74";
    IEntityreturnCode["R_R75"] = "R75";
    IEntityreturnCode["R_R76"] = "R76";
    IEntityreturnCode["R_R80"] = "R80";
    IEntityreturnCode["R_R81"] = "R81";
    IEntityreturnCode["R_R82"] = "R82";
    IEntityreturnCode["R_R83"] = "R83";
    IEntityreturnCode["R_R84"] = "R84";
    IEntityreturnCode["R_R94"] = "R94";
    IEntityreturnCode["R_R95"] = "R95";
    IEntityreturnCode["R_R97"] = "R97";
    IEntityreturnCode["R_R98"] = "R98";
    IEntityreturnCode["R_R99"] = "R99";
    IEntityreturnCode["C_C01"] = "C01";
    IEntityreturnCode["C_C02"] = "C02";
    IEntityreturnCode["C_C03"] = "C03";
    IEntityreturnCode["C_C04"] = "C04";
    IEntityreturnCode["C_C05"] = "C05";
    IEntityreturnCode["C_C06"] = "C06";
    IEntityreturnCode["C_C07"] = "C07";
    IEntityreturnCode["C_C08"] = "C08";
    IEntityreturnCode["C_C09"] = "C09";
    IEntityreturnCode["C_C10"] = "C10";
    IEntityreturnCode["C_C11"] = "C11";
    IEntityreturnCode["C_C12"] = "C12";
    IEntityreturnCode["C_C13"] = "C13";
    IEntityreturnCode["C_C61"] = "C61";
    IEntityreturnCode["C_C62"] = "C62";
    IEntityreturnCode["C_C63"] = "C63";
    IEntityreturnCode["C_C64"] = "C64";
    IEntityreturnCode["C_C65"] = "C65";
    IEntityreturnCode["C_C66"] = "C66";
    IEntityreturnCode["C_C67"] = "C67";
    IEntityreturnCode["C_C68"] = "C68";
    IEntityreturnCode["C_C69"] = "C69";
})(IEntityreturnCode = exports.IEntityreturnCode || (exports.IEntityreturnCode = {}));
var IEntityreturnInactive;
(function (IEntityreturnInactive) {
    IEntityreturnInactive[IEntityreturnInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    IEntityreturnInactive[IEntityreturnInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(IEntityreturnInactive = exports.IEntityreturnInactive || (exports.IEntityreturnInactive = {}));
var IEntityreturnFrozen;
(function (IEntityreturnFrozen) {
    IEntityreturnFrozen[IEntityreturnFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    IEntityreturnFrozen[IEntityreturnFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(IEntityreturnFrozen = exports.IEntityreturnFrozen || (exports.IEntityreturnFrozen = {}));
